
export function useCountdown() {
  const target = new Date("2025-12-03T07:30:00-05:00") // 29th Nov 2025 - 12:00 AM (EST)
  const now = ref(new Date())
  let intervalId = null

  onMounted(() => {
    intervalId = setInterval(() => {
      now.value = new Date()
    }, 1000)
  })

  onBeforeUnmount(() => {
    clearInterval(intervalId)
  })

  const timeLeft = computed(() => {
    const diff = target - now.value
    if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 }

    const totalSec = Math.floor(diff / 1000)
    return {
      d: Math.floor(totalSec / 86400),
      h: Math.floor((totalSec % 86400) / 3600),
      m: Math.floor((totalSec % 3600) / 60),
      s: totalSec % 60
    }
  })

  return { timeLeft }
}
